@let previewContent = contentValue();
@let plainTextLength = contentLength();

<form [formGroup]="form" class="edit-modal__form">
  @if (!isPreviewMode()) {
    <div class="edit-modal__editor-wrapper">
      <ngx-editor-menu [editor]="editor" [toolbar]="toolbar" />
      <ngx-editor
        [editor]="editor"
        formControlName="content"
        [placeholder]="'shop-settings.content.edit-modal.placeholder' | translate"
      />
    </div>
  } @else {
    <div class="edit-modal__preview" [innerHTML]="previewContent"></div>
  }
  <div class="edit-modal__meta">
    <span>{{ plainTextLength }} / {{ maxLength }}</span>

    @if (form.controls.content.invalid && form.controls.content.touched) {
      <span class="edit-modal__error">
        {{ 'shop-settings.content.edit-modal.validators.contentLengthValidator1' | translate }}
        {{ maxLength }}
        {{ 'shop-settings.content.edit-modal.validators.contentLengthValidator2' | translate }}
      </span>
    }
  </div>
</form>
